import { createMockTestPayload } from "./apiPayload";
import { MakeQuestionAttempted } from "../../../Client/request";

export const processQuestionSubmission = async ({
  quest,
  questData,
  transcript,
  timeSpent,
  commulative,
  MockTestAttemptID,
  ExamId,
  audioUrl
}) => {
  const FormDataPayload = createMockTestPayload({
    quest: quest,
    questData: questData,
    userResponse: transcript || "",
    marksObtained: 100,
    timeTaken: timeSpent,
    commulative: commulative,
    mockTestAttemptID: MockTestAttemptID,
    examId: ExamId,
    aiResponse: {},
    audioUrl: audioUrl,
    majorAspects: questData?.MajorAspects || null,
    minorAspects: questData?.MinorAspects || null,
    optionNames: questData?.OptionNames || null
  });

  return MakeQuestionAttempted(FormDataPayload, 30000);
};
